// Module
var code = "<ng-include ng-if=\"!vm.showAskForInformation && (vm.budgetEstimate || vm.order.showMandatoryCredentialsWarning)\" class=\"wrapper\" src=\"'views/marketplace/marketplace-product-estimate-block.html'\"/> <ng-include ng-if=\"vm.showAskForInformation\" class=\"wrapper\" src=\"'views/marketplace/marketplace-contact-vendor.html'\"/> ";
// Exports
var _module_exports = code;;
var path = 'views/marketplace/marketplace-product-right-column.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;